<template>
  <div 
    class="block-wrap block-specification-list" 
    :style="source === 'edit_base' && notSupplierList.length ? {'max-height': '462px'} : {}"
  >
    <div class="sku-batch-row" v-if="specificationNames && specificationNames.length > 0">
      <template v-for="(sname, sindex) in specificationNames">
        <div
          class="sku-batch-item"
          v-if="sname.name && sname.checked"
          :key="sname.name + sindex"
        >
          <div class="sku-batch-item_label">{{ sname.name }}：</div>
          <el-select
            style="width: 180px"
            placeholder="全部"
            multiple
            collapse-tags
            :clearable="true"
            :disabled="isPureType"
            v-model="skuBatchUpdateForm[sname.name]"
            @change="getRenderList"
          >
            <el-option
              v-for="(item, vindex) in specifications[sindex].values"
              :key="sname.name + sindex + item.value + vindex"
              :label="item.value"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </template>
      <el-button v-if="specificationNames.filter(sn => sn.checked).length" type="link" @click="resetFilter" class="sku-batch-item"> 重置筛选条件 </el-button>
    </div>
    <div class="sku-batch-row" v-if="showSkuBatchUpdateLabels">
      <div
        v-for="(name, key) in skuBatchUpdateLabels"
        :key="key"
        class="sku-batch-item"
      >
        <div class="sku-batch-item_label">
          {{ name.label }}：
          <div v-if="name.input && name.input.subText" style="font-size:12px;color:#ccc;text-align:left;">{{name.input.subText}}</div>
        </div>

        <el-input-digit
          :disabled="isPureType"
          v-if="name.input.type === 'number'"
          v-model.number="skuBatchUpdateForm[key]"
          style="width: 80px"
          :nullable="true"
          v-bind="name.input.attrs"
        />
        <el-select
          :disabled="isPureType"
          v-else-if="name.input.type === 'select'"
          :clearable="true" 
          v-model="skuBatchUpdateForm[key]"
          placeholder="请选择"
          collapse-tags
          v-bind="name.input.attrs"
          style="width: 100px">
          <el-option
            v-for="time in name.items"
            :key="time.value"
            :label="time.label"
            :value="time.value">
          </el-option>
        </el-select>
        <template
          v-else-if="name.input.type === 'size'"
        >
            <el-input-digit
              v-model.number="skuBatchUpdateForm.length"
              style="width: 80px"
              :nullable="true"
              v-bind="name.input.x"
            /> X 
            <el-input-digit
              v-model.number="skuBatchUpdateForm.width"
              style="width: 80px"
              :nullable="true"
              v-bind="name.input.y"
            /> X 
            <el-input-digit
              v-model.number="skuBatchUpdateForm.height"
              style="width: 80px"
              :nullable="true"
              v-bind="name.input.z"
            />
        </template>
        <slot :name="`${key}BatchSlot`" v-else-if="name.isBatchSlot"></slot>
        <el-input
          v-else
          :disabled="isPureType"
          v-model="skuBatchUpdateForm[key]"
          style="width: 80px"
          v-bind="name.input.attrs"
        >
        </el-input>
      </div>
      <div class="sku-batch-item">
        <el-button v-if="!isNonInput" @click="skuBatch" :disabled="isPureType">批量设置</el-button>
        <template v-for="(item, index) in batchSetBtns">
          <el-dropdown v-if="item.subBtns && item.subBtns.length" :key="index" trigger="hover" @command="handleCommandBatchSet" style="margin-left: 10px;">
            <el-button> {{ item.title }}<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(subItem, subIndex) in item.subBtns" :key="subIndex" :command="subItem.command" :disabled="item.disabled">
                {{ subItem.label }}
                <el-tooltip v-if="subItem.tooltip" class="item" :content="subItem.tooltip" popper-width="190px" placement="top">
                  <i class="el-icon-question" style="line-height: 28px;margin-left: 5px;" />
                </el-tooltip>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span v-else :key="index" style="margin-left: 10px;">
            <el-button @click="handleCommandBatchSet(item.command)" :disabled="item.disabled">{{ item.label }}</el-button>
            <el-tooltip v-if="item.tooltip" class="item" :content="item.tooltip" popper-width="190px" placement="top">
              <i class="el-icon-question" style="line-height: 28px;margin-left: 5px;" />
            </el-tooltip>
          </span>
        </template>
        <slot name="skuBatchSlot"></slot>
      </div>
    </div>

    <el-table-grid
      v-if="tableColsChange && tableColsChange.length"
      :height="computedHeight"
      :cell-class-name="getCellClass"
      :span-method="arraySpanMethod"
      @selection-change="handleSelectionChange"
      :data="getShowList"
      v-on="$listeners"
      @row-click="clickTableRow" 
    >
      <el-table-column
        v-if="singleSelection"
        label=""
        width="60px"
      >
        <template slot-scope="{ row }">
          <slot name="selectionSlot" v-bind="{row}"></slot>
        </template>
      </el-table-column>
    <el-table-column v-else width="60px" type="selection"></el-table-column>
      <template v-for="(item, index) in specificationNames">
        <el-table-column
          :key="item.name + index"
          :label="item.name"
          v-if="item.name && item.checked"
          width="100"
        >
          <template slot-scope="{ row }">
            {{ getSpecValue(row, item.name) }} 
          </template>
        </el-table-column>
      </template>
      <el-table-column
        v-if="showImageCol"
        prop="imageUrl"
        width="120"
        label="预览图"
        align="center"
       :grid-overflow-tooltip="false"
      >
        <template slot-scope="{ row, $index }">
          <template v-if="(isGroupPuhuo && row.disabled) || row.isGray">
            <div style="background: #eee; height: 60px; width: 100%; padding: 20px; margin-left: -10px;">铺货时系统自动补全</div>
          </template>
          <div v-else style="margin: 8px 0px">
            <el-form-item :error="row[`imgUrlError`]">
              <ImgUpload
                :ref="`img_${$index}`"
                :width="60"
                :height="60"
                :size="100"
                :isPureType="isPureType"
                :onlyPreview="imgOnlyPreview"
                :file="getSkuImageUrl(row)"
                @upload-success="(url) => handleUploaderChanged(row, url)"
                @del="() => handleUploaderChanged(row, '')"
                @handleLoad="handleImgLoad(row, `img_${$index}`)"
                :isSingle="true"
                :uploadFunc="uploadFunc"
                v-bind="imgLimits"
              />
            </el-form-item>
          </div>
        </template>
        <template slot="header">
          <template v-if="isKuaiShou" >
            <span>预览图</span>
            <span>
              <el-switch :disabled="isPureType" v-model="isUploadSpecImg"></el-switch>
            </span>
            <el-tooltip class="item" effect="dark" content="是否上传规格图片" placement="top">
              <i class="el-icon-question" />
            </el-tooltip>
          </template>
          <template v-else-if="isPdd">
            <span style="color: red">*</span>预览图
          </template>
          <template v-else><span>预览图</span></template>
        </template>
      </el-table-column>
      <template v-if="value.isPreSale === 1 && isPdd">
        <el-table-column
          prop="skuPreSaleTime"
          width="145"
          label="预售时间"
        >
          <template slot="header">
            <template>
              预售时间 <el-button v-show="config.isSkuPreSaleDay != 1" style="margin-left: 10px;" type="link" @click="clearSkuPreSaleTime">清空</el-button>
            </template>
          </template>
          <template slot-scope="{row}">
            <el-date-picker
              v-model="row.skuPreSaleTime"
              type="date"
              placeholder="选择日期"
              style="width: 120px!important;"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"
              @change="fieldChanged"
              :disabled="config.isSkuPreSaleDay == 1"
            >
            </el-date-picker>
            <div v-if="row.skuPreSaleTime" class="text-999 ftsz12 text-center">需23:59:59前发出</div>
          </template>
        </el-table-column>
        <el-table-column v-if="config.isSkuPreSaleDay == 1" prop="skuPreSaleTimeDay" width="150px">
          <template slot="header">
            <el-link style="text-align: right" @click="handleSaleTimeDay(null, 0)">清空</el-link>
          </template>
          <template slot-scope="{ row }">
            <el-input v-model="row.skuPreSaleTimeDay" style="width:60px;" regexp="^([1-2]?[0-9]?)$" clearable @change="handleSaleTimeDay(row, 1)" />
            <span class="ft-12">天结束预售</span>
          </template>
        </el-table-column>
      </template>
        <template v-for="(col, colindex) in tableColsChange">
          <el-table-column
            v-if="col.visibleFn ? col.visibleFn() : !col.unvisible"
            :key="col.prop"
            :prop="col.prop"
            align="center"
            v-bind="{...col.attrs,'header-tooltip':null}"
          >
            <template slot="header" slot-scope="scope">
              <template v-if="col.headerSlot">
                <slot :name="col.prop + 'HeaderSlot'" :scope="scope"  :col="col"></slot>
              </template>
              <template v-else>
                <span v-if="col.attrs.requiredFn ? col.attrs.requiredFn() : !col.attrs.noRequired" style="color: red">*</span>
                {{ col.attrs.label }}
                <el-tooltip placement="top" v-if="col.attrs['header-tooltip']">
                  <div slot="content" v-html="col.attrs['header-tooltip']"></div>
                  <i style="margin-left: 5px; margin-right: 5px;" class="el-icon-question" />
                </el-tooltip>
                <span v-if="platform && col.previewPrice" class="price-preview-wrapper">
                  <template v-if="checkControllerPriceDatas[col.prop]">
                    <el-tooltip v-if="hasPriceWarning(col.prop)" placement="top">
                      <div slot="content" v-html="getPriceWarningContent(col.prop)"></div>
                      <i class="el-icon-warning warning-icon" />
                    </el-tooltip>
                  </template>
                  <el-tooltip content="根据平台铺货配置中价格配置，预览铺货后对应平台链接的价格" placement="top">
                    <el-link  type="text" @click="preViewPrice(col)"> 铺货{{col.attrs.label}}预览 </el-link>
                  </el-tooltip>
                </span>
              </template>
              <el-switch v-show="false" :disabled="isPureType" v-model="isUploadSpecImg"></el-switch>
            </template>
            <template slot-scope="{ row, $index }">
              <div v-if="row.isGray && colindex === 0" style="background: #eee; height: 60px; width: 100%; padding: 20px;margin-left: -10px;">铺货时系统自动补全</div>
              <el-form-item v-else :error="row[`${col.prop}Error`]">
                <template v-if="isGroupPuhuo && row.disabled && colindex === 0">
                  <span>铺货时系统自动补全</span>
                </template>
                <template v-else>
                  <slot v-if="col.slot" :name="col.prop + 'Slot'" v-bind="{row, $index}"></slot>
                  <template v-else-if="showBindSkuOuterId && col.prop === skuOuterIdKey">
                    <el-input v-model="row[skuOuterIdKey]" readonly @click="handleProductMapping($index)"/>
                  </template>
                  <template v-else-if="col.input">
                    <template v-if="col.input.type === 'number'">
                      <!-- <el-form-item :error="row[`${col.prop}Error`]"> -->
                        <el-input-digit
                          v-loading="!!col.isLoading"
                          v-model.number="row[col.prop]"
                          :nullable="true"
                          :disabled="col.disabledFn ? col.disabledFn(row) : isPureType"
                          v-bind="col.input.attrs"
                          @input="onInput(row, col.prop)"
                          @blur="onBlur(col.prop)"
                          @change="fieldChanged"
                        />
                        <!-- <el-button 
                          v-if="isYyjk && col.attrs.label === '条形码'"
                          type="text" 
                          style="display: block; margin-top: 5px;"
                          @click="handleNoUpc(row)"
                        >
                          商品没有条形码，请点击
                        </el-button> -->
                      <!-- </el-form-item> -->
                    </template>
                    <el-select
                      v-else-if="col.input.type === 'select'"
                      :clearable="true"
                      :disabled="col.disabledFn ? col.disabledFn(row) : isPureType"
                      v-model="row[col.prop]"
                      placeholder="请选择"
                      style="width: 100px"
                      collapse-tags
                      v-bind="col.input.attrs"
                      @change="fieldChanged">
                      <el-option
                        v-for="time in col.items"
                        :key="time.value"
                        :label="time.label"
                        :value="time.value">
                        <span v-if="time.description">
                          {{ time.label }}<em style="color: #CCC;font-style: inherit;"> {{ time.description }}</em>
                        </span>
                      </el-option>
                    </el-select>
                    <template
                      v-else-if="col.input.type === 'size'"
                    >
                        <el-input-digit
                          v-model.number="row[col.input.x.prop]"
                          :nullable="true"
                          style="width: 50px;"
                          v-bind="col.input.x"
                        /> X 
                        <el-input-digit
                          v-model.number="row[col.input.y.prop]"
                          :nullable="true"
                          style="width: 50px;"
                          v-bind="col.input.y"
                        /> X 
                        <el-input-digit
                          v-model.number="row[col.input.z.prop]"
                          :nullable="true"
                          style="width: 50px;"
                          v-bind="col.input.z"
                        />
                    </template>
                    <el-input
                      v-else-if="col.input.type === 'text'"
                      v-model="row[col.prop]"
                      :disabled="col.disabledFn ? col.disabledFn(row) : isPureType"
                      v-bind="col.input.attrs"
                      @blur="onBlur(col.prop)"
                      @change="fieldChanged">
                    </el-input>
                    <template
                      v-else-if="col.input.type === 'distributionPriceInput'" 
                    >
                        <input-text
                            v-if="col.attrs.isDistributionState"
                            :isInput="clickedRowIndex === row._skuid"
                            :value="row.distributionLevelPriceObj[col.prop].distributorPrice"
                            :setType="row.distributionLevelPriceObj[col.prop].distributorPriceSetType"
                            :disabled="!row.erpOuterId && !row.erpSkuOuterId && !row.erpSysItemId"
                            @change="value => priceChange(row, row.distributionLevelPriceObj[col.prop], value)"
                        />
                        <span v-else>加入分销小店后显示分销价</span>
                    </template>

                    <span v-else>{{ row[col.prop] }}</span>
                  </template>
                  <template v-else>
                    {{ col.format ? col.format(row) : row[col.prop] }}
                  </template>
                </template>
            </el-form-item>
            </template>
          </el-table-column>
        </template>
    </el-table-grid>
    <div class="notSupplyAndDistributionBox" v-if="isDistribution && source === 'edit_base' && notSupplierList.length">
      <el-collapse :value="collapseValues" @change="handleChangeCollapse">
          <el-collapse-item name="1">
            <template slot="title">
                <div>无供分销对应关系的SKU信息已隐藏，如需查看请展开后查看详情</div>
                <span>{{collapseValues.length ? '收起' : '展开'}}</span>
            </template>
            <div class="notSupplyAndDistributionList">
              <el-table
                :data="notSupplierList"
                :stripe="false"
              >
                <el-table-column
                  v-if="multipleSelection"
                  width="60px"
                  type="selection"
                >
                </el-table-column>
                <el-table-column
                  v-else-if="singleSelection"
                  label=""
                  width="60px"
                >
                  <template slot-scope="{ row }">
                    <slot name="selectionSlot" v-bind="{row}"></slot>
                  </template>
                </el-table-column>
                <template v-for="(item, index) in specificationNames">
                  <el-table-column
                    :key="item.name + index"
                    :label="item.name"
                    v-if="item.name && item.checked"
                    width="100"
                  >
                    <template slot-scope="{ row }">
                      {{ getSpecValue(row, item.name) }} 
                    </template>
                  </el-table-column>
                </template>
                <!-- label="预览图" -->
                <el-table-column
                  v-if="showImageCol"
                  prop="imageUrl"
                  width="120"
                  label="预览图"
                  :grid-overflow-tooltip="false"
                >
                  <template slot-scope="{ row, $index }">
                    <template v-if="isGroupPuhuo && row.disabled">
                      <span>铺货时系统自动补全</span>
                    </template>
                    <div v-else style="margin: 14px 0px 5px">
                      <el-form-item :error="row[`imgUrlError`]">
                        <ImgUpload
                          :ref="`img_${$index}`"
                          :width="60"
                          :height="60"
                          :size="100"
                          :isPureType="isPureType"
                          :onlyPreview="imgOnlyPreview"
                          :file="getSkuImageUrl(row)"
                          @upload-success="(url) => handleUploaderChanged(row, url)"
                          @del="() => handleUploaderChanged(row, '')"
                          @handleLoad="handleImgLoad(row, `img_${$index}`)"
                          :isSingle="true"
                          :uploadFunc="uploadFunc"
                          v-bind="imgLimits"
                        />
                      </el-form-item>
                    </div>
                  </template>
                  <template slot="header">
                    <template v-if="isKuaiShou" >
                      <span>---</span>
                      <span>
                        <el-switch :disabled="isPureType" v-model="isUploadSpecImg"></el-switch>
                      </span>
                      <el-tooltip class="item" effect="dark" content="是否上传规格图片" placement="top">
                        <i class="el-icon-question" />
                      </el-tooltip>
                    </template>
                    <template v-else-if="isPdd">
                      <span style="color: red">*</span>预览图
                    </template>
                    <template v-else><span>预览图</span></template>
                  </template>
                </el-table-column>
                <template v-if="value.isPreSale === 1 && isPdd">
                  <el-table-column
                    prop="skuPreSaleTime"
                    width="145"
                    label="预售时间"
                  >
                    <template slot="header">
                      <template>
                        预售时间 <el-button v-show="config.isSkuPreSaleDay != 1" style="margin-left: 10px;" type="link" @click="clearSkuPreSaleTime">清空</el-button>
                      </template>
                    </template>
                    <template slot-scope="{row}">
                      <el-date-picker
                        v-model="row.skuPreSaleTime"
                        type="date"
                        placeholder="选择日期"
                        style="width: 120px!important;"
                        :picker-options="pickerOptions"
                        value-format="yyyy-MM-dd"
                        @change="fieldChanged"
                        :disabled="config.isSkuPreSaleDay == 1"
                      >
                      </el-date-picker>
                      <div v-if="row.skuPreSaleTime" class="text-999 ftsz12 text-center">需23:59:59前发出</div>
                    </template>
                  </el-table-column>
                  <el-table-column v-if="config.isSkuPreSaleDay == 1" prop="skuPreSaleTimeDay">
                    <template slot="header">
                      <el-link style="text-align: right" @click="handleSaleTimeDay(null, 0)">清空</el-link>
                    </template>
                    <template slot-scope="{ row }">
                      <el-input v-model="row.skuPreSaleTimeDay" regexp="^([1-2]?[0-9]?)$" clearable @change="handleSaleTimeDay(row, 1)" />
                      <span class="ft-12">天结束预售</span>
                    </template>
                  </el-table-column>
                </template>
                  <template v-for="(col, colindex) in tableColsChange">
                    <el-table-column
                      v-if="col.visibleFn ? col.visibleFn() : !col.unvisible"
                      :key="col.prop"
                      :prop="col.prop"
                      v-bind="col.attrs"
                    >
                      <template slot="header" slot-scope="scope">
                        <template v-if="col.headerSlot">
                          <slot :name="col.prop + 'HeaderSlot'" :scope="scope" :col="col"></slot>
                        </template>
                        <template v-else>
                          <span v-if="col.attrs.requiredFn ? col.attrs.requiredFn() : !col.attrs.noRequired" style="color: red">*</span
                          >{{ col.attrs.label }}
                          <el-tooltip v-if="platform && col.previewPrice" content="根据平台铺货配置中价格配置，预览铺货后对应平台链接的价格" placement="top" style="float: right;">
                            <el-button type="text" @click="preViewPrice(col)">铺货{{col.attrs.label}}预览</el-button>
                          </el-tooltip>
                        </template>
                        <!-- 快手预览图的el-switch 点击无效，没找到原因，暂时解决办法：在这里加上一个隐藏的el-switch  -->
                        <el-switch v-show="false" :disabled="isPureType" v-model="isUploadSpecImg"></el-switch>
                      </template>
                      <template slot-scope="{ row, $index }">
                        <template v-if="isGroupPuhuo && row.disabled && colindex === 0">
                          <span>铺货时系统自动补全</span>
                        </template>
                        <template v-else>
                          <slot v-if="col.slot" :name="col.prop + 'Slot'" v-bind="{row, $index}"></slot>
                          <template v-else-if="col.input">
                            <template v-if="col.input.type === 'number'">
                              <el-form-item :error="row[`${col.prop}Error`]">
                                <el-input-digit
                                  v-model.number="row[col.prop]"
                                  :nullable="true"
                                  :disabled="col.disabledFn ? col.disabledFn(row) : isPureType"
                                  v-bind="col.input.attrs"
                                  @input="onInput(row, col.prop)"
                                  @blur="onBlur(col.prop)"
                                  @change="fieldChanged"
                                />
                              </el-form-item>
                            </template>
                            <el-select
                              v-else-if="col.input.type === 'select'"
                              :clearable="true"
                              :disabled="col.disabledFn ? col.disabledFn(row) : isPureType"
                              v-model="row[col.prop]"
                              placeholder="请选择"
                              collapse-tags
                              style="width: 100px"
                              @change="fieldChanged">
                              <el-option
                                v-for="time in col.items"
                                :key="time.value"
                                :label="time.label"
                                :value="time.value">
                                <span v-if="time.description">
                                  {{ time.label }}<em style="color: #CCC;font-style: inherit;"> {{ time.description }}</em>
                                </span>
                              </el-option>
                            </el-select>
                            <el-input
                              v-else-if="col.input.type === 'text'"
                              v-model="row[col.prop]"
                              :disabled="col.disabledFn ? col.disabledFn(row) : isPureType"
                              v-bind="col.input.attrs"
                              @blur="onBlur(col.prop)"
                              @change="fieldChanged">
                            </el-input>

                            <span v-else>{{ row[col.prop] }}</span>
                          </template>
                          <template v-else>
                            {{ col.format ? col.format(row) : row[col.prop] }}
                          </template>
                        </template>
                      </template>
                    </el-table-column>
                  </template>
              </el-table>
            </div>
          </el-collapse-item>
      </el-collapse>
    </div>
    <PreviewPriceDialog ref="previewPriceDialogRef"></PreviewPriceDialog>
    <!-- 商品编码映射 -->
    <ProductMappingDialog ref="productMappingDialog" :baseItemId="baseItemId"/>
     <!-- 添加弹窗组件 -->
    <NoUpcDialog ref="noUpcDialog" @success="handleNoUpcSuccess" />
    <EditPriceDialog ref="EditPriceDialogRef"></EditPriceDialog>
  </div>
</template>

<script>
import ImgUpload from "@/components/Uploads/ImgUpload";
import PreviewPriceDialog from "./PreviewPriceDialog"
import ProductMappingDialog from '@/components/prod/center/dialogs/ProductMappingDialog.vue';
import { preViewSalePrice, getErpStock2 } from "@/servers/prod/center/index.js";
import { detailPreCheckControllerPrice } from '@/api/prod/center';
import { PLATFORMS } from '@/dictionary/platforms';
import dayjs from 'dayjs';
import { cloneDeep } from 'lodash';
import { mapGetters } from "vuex";
import ListLazyImg from '@components/ListLazyImg';
import NoUpcDialog from '@/components/prod/center/dialogs/NoUpcDialog.vue';
import EditPriceDialog from './EditPriceDialog.vue';  
import TemplateBlock from '../XhsInfoForm/TemplateBlock.vue';
import InputText from  '@/pages/supplier/distributor/price/components/inputText.vue'
import 
{ getUpdateSinglePrice, 
  batchUpdatePriceCancel,
} from "@/servers/supplier/index.js"

export default {
  inject: {
    isGroupPuhuo: { // 是否组合铺货
      default: false
    },
    noSpPic: {
      default: false
    }, // 不展示规格图片
    platform: {
      default: ''
    },
    openSource:{default:null}
  },
  model: {
    prop: "list",
    event: "change",
  },
  components: {
    ImgUpload,
    PreviewPriceDialog,
    ProductMappingDialog,
    NoUpcDialog,
    EditPriceDialog,
    ListLazyImg,
    TemplateBlock,
    InputText,
  },
  props: {
    baseItemId: String,
    showBindSkuOuterId: Boolean,
    outerProductId: String,
    skuOuterIdKey: {
      type: String,
      default: "skuOuterId",
    },
    pureType: {
      type: Number,
      default: 0
    },
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    specifications: {
      type: Array,
      default() {
        return [];
      },
    },
    extendAttr: {
      type: Array,
      default() {
        return [];
      },
    },
    skuSpecificationsKey: {
      type: String,
      default: "skuSpecifications",
    },
    tableCols: {
      // {prop: "price", attrs: {label: '价格', width: "90px"}, input: {type: 'number', attrs: {precision: 2}}}
      type: Array,
      default() {
        return [];
      },
    },
    imgLimits: {
      type: Object,
      default: () => {
        return {}
      }
    },
    validateSkuRowPrice: Function,
    imgOnlyPreview: {
      // 图片是否只能预览
      type: Boolean,
      default: true,
    },
    uploadFunc: {
      type: Function,
    },
    isPdd: {
      type: Boolean,
      default: false,
    },
    isKuaiShou: {
      type: Boolean,
      default: false
    },
    isYyjk: {
      type: Boolean,
      default: false
    },
    isXhs: {
      type: Boolean,
      default: false
    },
    erpStockImport: {
      // 是否支持erp库存一键填充
      type: Boolean,
      default: false,
    },
    outerId: {
      // 商品款式编码
      type: String,
      default: "",
    },
    uploadSpecImg: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default() {
        return {};
      },
    },
    showImgCol: {
      type: Boolean,
      default: true
    },
    // 是否需要单选操作列
    singleSelection: {
      type: Boolean,
      default: false
    },
    // 是否需要Selection操作列
    multipleSelection: {
      type: Boolean,
      default: false
    },
    // 铺货配置
    config: {
      type: Object,
      default: () => ({}),
    },
    source:{
      type: String,
      default: ''
    },
    isDistribution:{
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      skuBatchUpdateForm: {}, // 批量设置的数据
      valueForm: {},
      isUploadSpecImg: this.uploadSpecImg,
      isPureType: false,
      tipText:'',
      renderList: [],
      isRenderListChange: false,
      isUpdatingPriceErrors: false,
      selectList:[],
      operateSkuIndex: -1,
      checklist:[],
      collapseValues:[],
      currentRow:null,// 当前操作的行
      checkControllerPriceDatas: {},
      mergeInfo:{}, // 存储合并信息的对象
      clickedRowIndex:-1,
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    showImageCol() {
      const hasSpecs = !!this.specificationNames.filter(sn => sn.checked).length
      if(!hasSpecs) {
        return false
      }
      if(!this.showImgCol)  return false
      return !this.noSpPic && this.platform !== 'alibaba'
    },
    tableColsChange() {
      const  tableCols = cloneDeep(this.tableCols);

      if(this.pureType) {
        // 如果是纯商品删除ERP主商家编码、ERP sku编码
        return tableCols.splice(0, this.tableCols.length -2)
      }
      return tableCols
    },
    isNonInput() {
      return this.tableCols.every(item => !item.input);
    },
    // 规格名
    specificationNames() {
      return (this.specifications || []).filter(Boolean).map((item) => ({ name: item.name, checked: !!(item.checked || item.checked === undefined) }));
    },
    skuBatchUpdateLabels() {
      let labels = {};
      this.tableCols.forEach((item) => {
        const visible = item.visibleFn ? item.visibleFn() : !item.unvisible
        if (item.input && !item.input.onlyTable && visible) {
          labels[item.prop] = { label: item.attrs.label, input: item.input, items: item.items,isBatchSlot:item.isBatchSlot };
        }
      });
      return labels;
    },
    showSkuBatchUpdateLabels() {
      if (Object.keys(this.skuBatchUpdateLabels).length > 0) {
        return true;
      }
      if (this.$slots.skuBatchSlot) {
        return true;
      }
      return false;
    },
    computedValueForm() {
      let form = {};
      this.tableCols.forEach((item) => {
        if (item.input) {
          form[item.prop] = "";
        }
      });
      return form;
    },
    batchSetBtns() {
      let btns = [
        { label: '填充erp库存', command: 'fillErpStock', visible: this.erpStockImport, disabled: this.isPureType, tooltip: '指获取到当前快麦ERP中关联ERP商品的可用库存+虚拟库存，并填充到基础资料库存' },
        { label: '批量绑定商家编码', command: 'bindSkuOuterId', visible: this.showBindSkuOuterId },
        {
          title: '批量修改价格',
          subBtns: [
            { label: '批量修改拼单价', command: 'multiPrice', visible: ['pdd'].includes(this.platform) },
            { label: '批量修改单买价', command: 'singlePrice', visible: ['pdd'].includes(this.platform) },
          ]
        },
        {
          title: ['tb'].includes(this.platform) ? '批量操作平台规格编码' : '批量操作sku编码',
          subBtns: [
            { label: '按基础资料商品编码填充', command: 'fillSkuOuterId', visible: ['pdd', 'tb', 'fxg','wxsph'].includes(this.platform) && this.openSource != 'shopGoods' },
            { label: ['tb'].includes(this.platform) ? '清空平台规格编码' : '清空sku编码', command: 'clearSkuOuterId', visible: ['pdd', 'tb', 'fxg','wxsph'].includes(this.platform) && this.openSource != 'shopGoods' },
          ]
        }
      ]
      return btns.filter(item => {
        if(item.subBtns?.length) {
          item.subBtns = item.subBtns.filter(subItem => subItem.visible)
          return item.subBtns.length
        } 
        return item.visible
      })
    },
    computedHeight() {
      // if (this.list.length) {
      //   return ~~(this.list.length * 60) + 'px'
      // } else {
      //   return '58px'
      // }
      return "300px";
    },
    pickerOptions() {
      const self = this;
      return {
        disabledDate(time) {
          return (time.getTime() < Date.now() + ((self.value.preSaleTime || 0) - 1) * 86400000) || (time.getTime() > Date.now() + 2505600000);
        },
      };
    },
    getShowList(){
      if(this.platform === 'xhs') {

        // 分销商品&商品编辑-基础资料下 不展示无供分销关系的sku
        let list = this.isDistribution && this.source === 'edit_base' ? this.renderList.filter(item =>item.supplierItemId) : this.renderList
        // 根据发货模式的现货+预售模式的预售发货时间 根据发货时效顺序排列展示
        // Group by skuId
        const grouped = {};
        list.forEach(item => {
          if (!grouped[item._skuid]) {
            grouped[item._skuid] = [];
          }
          grouped[item._skuid].push(item);
        });

        // Sort each group
        Object.keys(grouped).forEach(skuId => {
          grouped[skuId].sort((a, b) => {
            const getPriority = (name) => {
              if (!name) return 0;
              if (name.includes('当日发货')) return 1;
              if (name.includes('24小时内发货')) return 2;
              if (name.includes('48小时发货')) return 3;
              
              // Extract number from "X天内发货"
              const match = name.match(/(\d+)天内发货/);
              return match ? 4 + parseInt(match[1]) : 0;
            };
            
            return getPriority(a.spotPresaleName) - getPriority(b.spotPresaleName);
          });
        });

        // Flatten back to array
        return Object.values(grouped).flat();
      } else {
      // 分销商品&商品编辑-基础资料下 不展示无供分销关系的sku
      return this.isDistribution && this.source === 'edit_base' ? this.renderList.filter(item =>item.supplierItemId) : this.renderList
      }
    },
    notSupplierList(){
      return this.list.filter(item => !item.supplierItemId)
    }
  },
  watch: {
    list: {
      handler(ls) {
        if(this.isRenderListChange) {
          this.isRenderListChange = false
          return
        }
        this.resetFilter()
      },
      immediate: true,
      deep: true
    },
    renderList: {
      handler(ls) {
        if(this.isUpdatingPriceErrors) return
        const list = cloneDeep(this.list)
        ls.forEach(renderItem => {
          let findIndex = this.list.findIndex(item => item._skuid === renderItem._skuid)
          if(this.platform === 'kuaishou') {
            findIndex = this.list.findIndex(item => item._skuid === renderItem._skuid && item.spotPresaleName === renderItem.spotPresaleName)
          }
          if(this.platform === 'xhs') {
            findIndex = this.list.findIndex(item => item._skuid === renderItem._skuid && item.spotPresaleName === renderItem.spotPresaleName)
          }
          list.splice(findIndex, 1, cloneDeep(renderItem))
        })
        this.isUpdatingPriceErrors = true
        this.updatePriceErrors(ls)
        this.$nextTick(() => {
          this.isUpdatingPriceErrors = false
        })
        this.$emit('change', list);
        this.fieldChanged();
        this.isRenderListChange = true
        if(this.platform === 'shein'){
          // 计算合并单元格信息
          this.calculateMergeInfo();
        }
      },
      deep: true
    },
    isUploadSpecImg(val) {
      this.$emit('specification-upload-img', val)
    },
    pureType:{
      handler(val){
        this.isPureType = val === 0 ? false : true;
      },
      immediate: true
    },
  },
  methods: {
    updatePriceErrors(ls){
      if(this.isPdd && this.validateSkuRowPrice) {
        for(let row of ls) {
          this.validateSkuRowPrice(row, 'singlePrice')
          this.validateSkuRowPrice(row, 'multiPrice')
        }
      }
    },
    getRenderList() {
      const renderList = this.list.filter((item) => {
        return item[this.skuSpecificationsKey].every(c => {
          return !this.skuBatchUpdateForm[c.name]?.length || this.skuBatchUpdateForm[c.name].includes(c.value)
        })
      });
      this.renderList = renderList
      return renderList
    },
    resetFilter() {
      this.specificationNames.forEach((item, index) => {
        this.skuBatchUpdateForm[item.name] = []
      });
      this.getRenderList()
    },
    setRenderList(list) {
      this.renderList = list;
    },
    handleSelectionChange(select) {
      this.selectList = select
    },
    getNeedBatchList() {
      let list = this.selectList.length ? this.selectList : this.renderList;
      return list.filter(item => !item.isGray && !(this.isGroupPuhuo && item.disabled))
    },
    getSpecValue(row, name) {
      const skuSpecifications = row[this.skuSpecificationsKey] || []
      const findItem = skuSpecifications.find(item => item.name === name) || {}
      return findItem.value
    },
    getSkuImageUrl(row) {
      let imageUrl = row[this.skuSpecificationsKey][0]?.imageUrl || '';
      imageUrl = this.isPdd ? row.skuImg : imageUrl
      return imageUrl === '/resources/css/build/images/no_pic.png' ? '' : imageUrl;
    },
    async handleImgLoad(row, refName) {
      let errMsg = await this.$refs[refName].method_validImage()
      row.imgUrlError = errMsg
    },
    handleUploaderChanged(row, url) {
      // 拼多多需要读取配置 是否变更规格图片
      if (!this.isPdd) {
        row[this.skuSpecificationsKey][0].imageUrl = url;
      } 
      row.skuImg = url;
      row.imgUrlError = this.isPdd && !url ? '请上传预览图' : '';
      this.fieldChanged();
    },
    fieldChanged() {
      this.$emit('fieldChanged');
    },
    initSkuBatchUpdateForm() {
      const spNamesForm = {};
      this.specificationNames.forEach((item, index) => {
        spNamesForm[item.name] = [];
      });

      this.skuBatchUpdateForm = {
        ...spNamesForm,
        ...JSON.parse(JSON.stringify(this.computedValueForm)),
      };
    },
    // 批量设置
    skuBatch() {
      // 检查是否有值需要批量设置
      const hasValueToUpdate = Object.values(this.skuBatchUpdateForm).some(
        val => val !== undefined && val !== null && val !== ''
      );
      // if (!hasValueToUpdate) return;
      const targetItems = this.getNeedBatchList();
      const targetSkuIds = new Set(targetItems.map(item => item._skuid));
      // 获取批量设置表单中有效的列（排除隐藏列）
      const validBatchKeys = new Set(Object.keys(this.skuBatchUpdateLabels));
      this.renderList.forEach(item => {
        // 跳过置灰和不可编辑的行
        if (item.isGray || (this.isGroupPuhuo && item.disabled)) return;
        if (targetSkuIds.has(item._skuid)) {
          Object.entries(this.skuBatchUpdateForm).forEach(([key, value]) => {
            // 跳过隐藏列
            if (!validBatchKeys.has(key)) return;
            // 查找对应列，判断是否 disabled
            const col = this.tableColsChange.find(c => c.prop === key);
            const isColDisabled = col && col.disabledFn ? col.disabledFn(item) : false;
            // 跳过 disabled 的列（列级 disabled 或全局 isPureType）
            if (isColDisabled || this.isPureType) return;
            if (value !== undefined && value !== null && value !== '') {
              this.$set(item, key, value === 0 ? 0 : value || item[key] || "")
            }
          });
        }
      });
      // UI更新后再继续更新组件内部实现的更新，不然会覆盖上面更新的内容
      this.$nextTick(() => {
        this.$emit("batchUpdate");
      })
    },
    // erp库存一键填充
    async erpStockClick(selectList) {
      let baseItemIds = selectList.map(({baseItemId}) => baseItemId).filter(Boolean);
      if (!baseItemIds.length) {
        // return this.$message.error('无baseItemId，无法填充')
        return this.$message.error('规格未匹配系统商品，无法填充')
      }
      const res = await getErpStock2({baseItemId: baseItemIds[0]})
      if (res) {
        this.renderList.forEach(item => {
          if (selectList.some(selectItem => selectItem._skuid === item._skuid)) {
            const erpStockItem = res.find(r => r.skuId === item.id);
            item.stock = erpStockItem ? Math.max(0, erpStockItem.stock) : 0;
          }
        });
        this.$message.success("填充成功");
      } else {
        this.$message.error("填充失败");
      }
      if (this.isPdd) {
        this.$emit("validateSkuPrices"); // 校验拼单价和单买价
      }
    },
    handleBatchProductMapping() {
      this.handleProductMapping(-1);
    },
    handleProductMapping(skuIndex) {
      this.$refs.productMappingDialog.handleShow({
        onSuccess: (selectRowData) => {
          let selectList = this.getNeedBatchList()
          if (this.operateSkuIndex !== -1) {
            selectList = [this.renderList[this.operateSkuIndex]]
          } 
          selectList.forEach(selectItem => {
            const item = this.renderList.find(item => item._skuid === selectItem._skuid);
            if (item) {
              this.$set(item, this.skuOuterIdKey, selectRowData.skuOuterId)
              this.$set(item, 'code', selectRowData.skuOuterId)
              this.$set(item, 'companyId', item.companyId || selectRowData.companyId)
              this.$set(item, 'baseSkuId', selectRowData.id)
              this.$set(item, 'baseItemId', selectRowData.baseItemId)
              this.$set(item, 'outerProductId', this.outerProductId || this.list[0]?.outerProductId || '')
            }
            if(this.platform === 'tb') {
              this.$set(item, 'skuStock',  Math.max(0, selectRowData.stock) )
            }
          });
        },
        onCancel:() => {
          this.operateSkuIndex = -1;
        }
      });
      this.operateSkuIndex = skuIndex;
    },
    handleCommandBatchSet(command) {
      const selectList = this.getNeedBatchList();
      if (selectList.length === 0) {
        this.$message.error('请选择需要批量修改的SKU');
        return;
      }
      if(command === 'fillErpStock') {
        this.erpStockClick(selectList)
      } else if(command === 'bindSkuOuterId') {
        this.handleBatchProductMapping()
      } else if(['multiPrice', 'singlePrice'].includes(command)) {
        this.batchSetPrice(command, selectList)
      } else if(['fillSkuOuterId', 'clearSkuOuterId'].includes(command)) {
        let platformSkuOuterIdKeyMap = {
          fxg: 'outerSkuId',
          wxsph:'platformSkuCode',
        }
        let baseSkuOuterIdKeyMap = {
          pdd: 'outSkuSn',
          tb: 'skuOuterId',
          fxg: 'code',
          wxsph:'skuCode',
        }
        let platformSkuOuterIdKey = platformSkuOuterIdKeyMap[this.platform] || 'outSkuPlatform'
        let baseSkuOuterIdKey = baseSkuOuterIdKeyMap[this.platform] || 'skuOuterId'
        this.batchUpdateRenderListSkuOuterId(platformSkuOuterIdKey, baseSkuOuterIdKey, selectList, command === 'clearSkuOuterId')
      }
    },
    
    batchSetPrice(command, selectList) {
      const specificationNames = this.specificationNames.filter(item => item.checked).map(item => item.name);
      const opts = {
        type: command === 'multiPrice' ? 'sales' : 'market',
        title: command === 'multiPrice' ? '批量修改拼单价' : '批量修改单买价',
        platformType: this.platform,
        specificationNames,
        skuList: selectList.filter(item => item.baseSkuId),
        baseItemId: this.baseItemId,
        okFn: tableList => {
          this.renderList.map(item => {
            const specValue = item['skuSpecifications'].map(item => item.value).join(',');
            const targetItem = tableList.find(row => row.specValue === specValue);
            if (targetItem) {
              this.$set(item, command, targetItem.modifiedPrice);
            }
          });
        },
      };
      this.$refs.EditPriceDialogRef.method_open(opts);
    },
    batchUpdateRenderListSkuOuterId(platformSkuOuterIdKey, baseSkuOuterIdKey, batchList, isClear) {
      const targetSkuIds = new Set(batchList.map(item => item._skuid));
       this.renderList.forEach(item => {
        if (targetSkuIds.has(item._skuid)) {
          this.$set(item, platformSkuOuterIdKey, isClear ? '' : item[baseSkuOuterIdKey])
        }
      });
    },
    clearSkuPreSaleTime(){
      this.list.forEach(item => {
        item.skuPreSaleTime = '';
      })
    },
    getCellClass({ row, column, columnIndex }) {
      if (this.isPdd) {
        if (
          column.property === "multiPrice" ||
          column.property === "singlePrice"
        ) {
          return "pdd-cell";
        }
      }
      // if (row.disabled && columnIndex === this.specifications.length) {
      //   return 'disabled-cell'
      // }
      return "";
    },
    calculateMergeInfo() {
      // 初始化合并信息
      this.mergeInfo = {};
      let startIndex = 0;
      let currentValue = '';
      this.getShowList.forEach((row, index) => {
        let curName = this.getSpecValue(row, this.specificationNames[0].name)
        if (index === 0) {
          // 第一个单元格，初始化
          currentValue = curName
          startIndex = index;
        } else if (curName === currentValue) {
          // 与前一个单元格内容相同，继续累加
        } else {
          // 内容不同，记录合并信息，并更新当前值和起始索引
          this.mergeInfo[startIndex] = {
            rowspan: index - startIndex,
            colspan: 1
          };
          currentValue = curName;
          startIndex = index;
        }
      });
      // 处理最后一组相同内容的单元格
      if (startIndex !== this.getShowList.length - 1) {
        this.mergeInfo[startIndex] = {
          rowspan: this.getShowList.length - startIndex,
          colspan: 1
        };
      } else {
        // 如果最后一个单元格也是单独一组，也需要记录（rowspan为1）
        this.mergeInfo[startIndex] = {
          rowspan: 1,
          colspan: 1
        };
      }
    },
    arraySpanMethod({ row, columnIndex,column,rowIndex }) {
      let disabled = row.disabled || row.isGray || false;
      if(this.platform === 'shein'){
        // 第一个规格属性列、【供方货号】列进行合并
        if(columnIndex === 1 || column.property === 'skcSupplierCode'){
          // 主销售属性单元格合并
          const mergeInfo = this.mergeInfo[rowIndex];
          if (mergeInfo) {
            return [mergeInfo.rowspan, mergeInfo.colspan];
          } else {
            // 非合并单元格，返回 [0, 0] 表示该单元格不显示
            return [0, 0];
          }
        }
        return [1, 1];
      } 

      // if (this.isGroupPuhuo) {
      //   row.disabled = !row.spec0
      //   if (row.disabled) {
      //     if (columnIndex <= this.specifications.length - 1) {
      //       return [1, 1]
      //     } else if (columnIndex === this.specifications.length) {
      //       return [1, this.tableCols.length + 1]
      //     } else if (columnIndex > this.specifications.length) {
      //       return [0, 0]
      //     }
      //   }
      // }
      const specsColmns = this.specificationNames.filter(item => item.name && item.checked)
      if(disabled && columnIndex == specsColmns.length + 1) {
        return [1, this.tableColsChange.length + 1]
      } else if(disabled && columnIndex > specsColmns.length + 1) {
        return [1, undefined]
      }
     
    },
    onInput(row, field) {
      if(this.isPdd && this.validateSkuRowPrice) {
        this.validateSkuRowPrice(row, field)
      }
       // 如果是现货SKU的价格变化，同步到同规格预售SKU
       if (!row.isPresale && (field === 'price' || field === 'originalPrice') && this.platform === 'xhs') {
        this.renderList.forEach(sku => {
          if (sku._skuid === row._skuid && sku.isPresale) {
            sku[field] = row[field];
          }
        });
      }
      this.$emit('validateSkuRowPrice', row, field);
    },
    onBlur(field) {
      this.$emit('skuFieldBlur', field)
    },
    // 预售时间 - 天数
    handleSaleTimeDay(row, type) {
      // 清空
      if (type === 0) {
        this.list.forEach(item => {
          item.skuPreSaleTimeDay = '';
          item.skuPreSaleTime = '';
        });
      }
      // 单个修改
      if (type === 1) {
        if (row.skuPreSaleTimeDay && row.skuPreSaleTimeDay < 3) {
          this.$message.warning('时间不能小于3天且大于29天');
          row.skuPreSaleTimeDay = 3;
        }
        row.skuPreSaleTime = row.skuPreSaleTimeDay ? dayjs().add(row.skuPreSaleTimeDay * 1, 'd').format('YYYY-MM-DD') : '';
      }
    },
    handleChangeCollapse(val){
      this.collapseValues = val
    },
    getPreViewPriceParams(col) {
      const { prop, previewPriceType = 'sales' } = col;
      const skuNames = this.specificationNames.filter(item => item.name && item.checked).map(item => item.name)
      const skuData = this.list.map(row => {
        const names = skuNames.map(name => {
          return this.getSpecValue(row, name)
        })
        const itemData =  {
          specDetailName: names.join(','),
          price: String(row[prop] || 0),
          baseSkuId: row.baseSkuId
        }
        if(this.platform === 'pdd' && previewPriceType === 'market') {
          itemData.priceMulti = String(row.multiPrice || 0)
        }
        return itemData
      })
      return {
        type: previewPriceType,
        shopType: PLATFORMS[this.platform]?.shopType,
        skuData,
        baseItemIdList: [this.baseItemId],
        hasControlPrice: true
      }
    },

    async preViewPrice(col) {
      const skuNames = this.specificationNames.filter(item => item.name && item.checked).map(item => item.name)
      const requestParams = this.getPreViewPriceParams(col)
      this.$refs.previewPriceDialogRef.openDialog({
        requestParams, 
        platform: this.platform,
        type: col.previewPriceType || 'sales',
        priceName: col.attrs.label,
        skuNames,
        isDistribution: this.checkControllerPriceDatas[col.prop]?.isDistribution
      })
      this.$set(this.checkControllerPriceDatas, col.prop, {
        ...this.checkControllerPriceDatas[col.prop],
        fenxiaoBreakPrice:0,
        shopPriceType:0
      });
    },
    async checkControllerPrice() {
      try {
        this.checkControllerPriceDatas = {};
        const shops = this.$store.getters.shops_authorizedShops(this.platform);
        const shopIds = shops.map(shop => shop.id);
        // 提前返回条件合并
        if (!this.baseItemId || !shopIds.length) {
          return;
        }
        const salesPriceCols = (this.tableCols || []).find(col => col.previewPrice && (!col.previewPriceType || col.previewPriceType === 'sales'));
        const marketPriceCols = (this.tableCols || []).find(col => col.previewPrice && col.previewPriceType === 'market');
        if (!salesPriceCols) return;
        const res = await detailPreCheckControllerPrice({
          itemId: this.baseItemId,
          shopIds,
          platformType: this.platform
        });
        
        if (!res?.data) return;
        
        const { data } = res;
        this.$set(this.checkControllerPriceDatas, salesPriceCols.prop, {
          fenxiaoBreakPrice: data.fenxiaoBreakPrice,
          isLimit: data.isLimit,
          isDistribution: data.isDistribution,
          shopPriceType: data.shopPriceType,
        })
        
        if(this.platform === 'pdd') {
          this.$set(this.checkControllerPriceDatas, marketPriceCols.prop, {
            fenxiaoBreakPrice: data.fenxiaoBreakPriceMulti,
            isLimit: data.isLimit,
            isDistribution: data.isDistribution,
            shopPriceType: data.shopPriceTypeMulti,
          })
        }
      } catch (error) {
        console.error('检查控制价失败:', error);
        this.$message.error('获取价格控制信息失败');
      }
    },
    hasPriceWarning(prop) {
      const priceData = this.checkControllerPriceDatas[prop];
      return (priceData.fenxiaoBreakPrice === 1 && priceData.isDistribution) || 
            priceData.shopPriceType === 1;
    },
    getPriceWarningContent(prop) {
      const priceData = this.checkControllerPriceDatas[prop];
      let content = '';
      if (priceData.fenxiaoBreakPrice === 1 && priceData.isDistribution) {
        content += `铺货价格已破价（铺货价格低于或高于分销控价），请查看详情${priceData.isLimit ? '，破价将限制整款商品发布' : ''}`;
      }
      if (priceData.shopPriceType === 1) {
        content += content ? '<br/>' : '';
        content += '铺货价格已经过价格配置计算，与列表价格不一致，请核对后铺货';
      }
      return content;
    },
    handleChangeCollapse(val){
      this.collapseValues = val
    },
     // ... 其他方法
     handleNoUpc(row) {
      this.currentRow = row;
      this.$refs.noUpcDialog.handleShow();
    },
    handleNoUpcSuccess({ frontImage, backImage }) {
      if(this.currentRow) {
        // 清空条形码值
        this.currentRow[this.tableCols[0].prop] = '';
        // 设置图片
        this.currentRow.skipUpcImg = {
          frontImage,
          backImage
        };
        this.fieldChanged();
      }
    },
    /**
     * 单击表格行
     */
    clickTableRow(row) {
        this.clickedRowIndex = row._skuid;
    },
    /**
     * 修改分销价
     */
    async priceChange(row, levelItem, value) {
        let erpOuterId = row.erpOuterId;
        let erpSkuOuterId = row.erpSkuOuterId;
        let params = {};
        let itemListParams = {
          outerId: erpOuterId,
          skuOuterId: erpSkuOuterId,
          erpItemId: row.erpSysItemId,
          erpSkuId: row.erpSkuId || 0,
        };

        levelItem.distributorPrice = value;

        if (!value) { // 清空分销价
            params = {
                cancelLevels: [levelItem.level],
                // skuOuterIds: [erpSkuOuterId]
                itemList: [itemListParams],
            }
            const res = await batchUpdatePriceCancel(params);
            if(!res) return;
            this.$message({
                message: '修改成功！',
                type: 'success',
            });
            this.getTrader();
            return;
        }
        params = {
            levelPrices: {
                level: levelItem.level,
                distributorPrice: levelItem.distributorPrice,
                controlPrice: levelItem.controlPrice,
            },
            ...itemListParams,
        };
        const res = await getUpdateSinglePrice(params);
        if(!res) return;
        this.$message({
            message: '修改成功！',
            type: 'success',
        });
    },
  },
  mounted() {
    this.initSkuBatchUpdateForm();
    if(this.openSource != 'shopGoods'){// 店铺商品页面进入的不调用下面的方法
      this.$nextTick(() => {
        this.checkControllerPrice()
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.block-wrap {
  border: 1px solid #dcdfe6;
}
.price-preview-wrapper {
  float: right;
}
.warning-icon {
  color: red; 
  font-size: 18px;
  margin-right: 5px;
}
.sku-batch-row {
  display: flex;
  flex-wrap: wrap;
  &:first-of-type{
    margin-top: 8px;
  }
  .sku-batch-item {
    display: flex;
    margin-bottom: 8px;
    margin-right: 8px;
    .sku-batch-item_label {
      min-width: 80px;
      max-width: 130px;
      text-align: right;
    }
  }
}
.block-specification-list {
  max-height: 420px;
  overflow-y: auto;
  ::v-deep .pdd-cell .cell {
    overflow: visible;
    padding: 5px;
  }
  ::v-deep .disabled-cell {
    background: #f6f6f6 !important;
    text-align: center;
    color: #aeadae;
    height: 60px;
  }
  ::v-deep .el-form-item__error {
    position: relative; 
  }
  ::v-deep .el-form-item__content {
    font-size: 12px;
  }
}

.el-switch{
  height: 40px;
}
span ::v-deep .el-switch__core{
  height: 16px!important;
  width: 30px!important;
}

span ::v-deep .el-switch__core::after{
  width: 14px;
  height: 14px;
  margin-top: -1px;
  margin-bottom: 2px;
}
span ::v-deep .el-switch.is-checked .el-switch__core::after {
  margin-left: -14px;
}
.notSupplyAndDistributionBox{
  // .notSupplyAndDistributionTitle{
  //   display: flex;
  //   padding: 6px 20px;
  //   justify-content: space-between;
  //   font-size: 14px;
  //   color: #afafaf;
  //   background: #f2f2f2;
  //   span{
  //     color: #66badf;
  //     cursor: pointer;
  //   }
  // }
  ::v-deep .el-collapse-item__header{
      display: flex;
      padding: 6px 20px;
      justify-content: space-between;
      font-size: 14px;
      color: #afafaf;
      background: #f2f2f2;
      span{
        color: #66badf;
        cursor: pointer;
      }
      .el-collapse-item__arrow{
        display: none;
      }
  }
  ::v-deep .notSupplyAndDistributionList .el-table__header-wrapper{
    display: none;
  }
  .notSupplyAndDistributionList{
    background: #e2e2e2;
    pointer-events: none;
    user-select: none; 
    ::v-deep .el-table__row td{
      background: #e2e2e2 !important;
    }
  }
}

::v-deep .el-loading-mask{
  .el-loading-spinner{
    margin-top: -10px;
  }
  .circular{
    width: 20px;
    height: 20px;
  }
}

</style>
